var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard__section animate-slide-in-down"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"dashboard__cards"},_vm._l((_vm.cards),function(card){return _c(_setup.MiniCard,{key:card.label,attrs:{"title":card.value,"subtitle":card.label,"icon":card.icon}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }